export const BLUE_LIT = '#28aae1'
export const LIGHT_BLUE_LIT = '#44c8f5'
export const GREEN_LIT = '#54c3a0'
export const GRAY_LIT = '#6d6e71'